<script setup>
import {ref} from "vue";
import { useRouter } from 'vue-router'
import SNBPolicy from "../../../../../layouts/nav/SNBPolicy.vue";

const router = useRouter()

const selectedOption = ref({ label: '', value: '' });

const personalList = [
  { label:"[현행]2025년 07월 23일", value: "personal20250723" },
  { label:"이전 변경 이력 없음", value: "" },
];

const onSelectPersonal = (option) => {
  if (option.value === '') {
    return; // 빈 값이면 조기 종료
  }

  selectedOption.value = option
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNBPolicy class="snb" />
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title">
              <h3>개인정보처리방침</h3>
            </div>
            <div class="content-title grid" style="justify-content: flex-end;">
              <KSASelect :options="personalList" class="select" @selectOption="onSelectPersonal" />
            </div>
              <!--v-if="selectedOption.value === 'personal20250725'"-->
            <div>
              한국반도체아카데미는 대한민국 헌법에 보장된 사생활의 비밀과 통신의 비밀보장을 위해 '정보통신망 이용촉진 등에 관한 법률'상의 개인정보 보호규정 및 정보통신부가 제정한 '개인정보 보호지침'을 준수하고 있으며, 회원의 개인정보를 적극적으로 보호하기 위해 다음과 같은 개인정보 보호 정책을 적용하고 있습니다.<br/><br/><br/>


              <b>1. 개인정보의 수집목적 및 이용</b><br/>
              한국반도체아카데미는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br/>
              ① 서비스 제공에 관한 통지, 계약 이행 및 서비스 제공에 따른 요금정산, 교육지원 및 교육이력관리, 서비스 제공에 따른 교육생모집, 교육생선발, 학습진행, 교육 콘텐츠 제공, 교육과정 만족도 조사 및 설문조사<br/>
              ② 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 가입 의사 확인, 연령확인, 불만처리 등 민원처리, 공지사항 전달, 불량회원의 부정이용 방지와 비인가사용 방지<br/>
              ③ 교육공동운영기관의 교육생모집, 교육생선발, 학습진행, 공동운영기관의 콘텐츠 제공 등<br/>
              ④ 반도체산업 정보전달에 활용, 산업계 뉴스 등 반도체산업 정보 전달<br/>
              ⑤ 마케팅 및 광고에 활용 이벤트 등 광고성 정보 전달<br/><br/><br/>


              <b>2. 개인정보의 수집범위</b><br/>
              한국반도체아카데미는 회원가입, 상담 등등의 서비스 계약의 성립 및 이행에 필요한 최소한의 정보만을 수집합니다.<br/>
              ① 개인 : 로그인ID, 비밀번호, 이름, 핸드폰번호, 이메일, 생년월일, 성별, 학력, 학교, 졸업상태, 거주 지역<br/>
              ② 기업 : 사업자등록번호, 기업명, 대표번호, 소재지, 담당자명, 담당자연락처, 이메일, 부서, 직책<br/><br/><br/>


              <b>3. 개인정보 수집에 대한 동의</b><br/>
              한국반도체아카데미는 회원가입약관의 내용에 대해 「동의한다」버튼 또는 「동의하지 않는다」버튼을 클릭할 수 있는 절차를 마련하여, 「동의한다」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.<br/><br/>
              <div class="table-form">
                <table class="horizontal">
                  <colgroup>
                    <col width="30%" />
                    <col />
                    <col width="20%" />
                  </colgroup>
                  <tr>
                    <th>목적</th>
                    <th>항목</th>
                    <th>보유기간</th>
                  </tr>
                  <tr>
                    <td>이용자 식별 및<br/>
                        본인여부 확인</td>
                    <td>아이디, 이름(담당자 이름),<br/>
                        비밀번호</td>
                    <td>회원탈퇴 시까지</td>
                  </tr>
                  <tr>
                    <td>고객서비스 이용에 관한 통지, CS대응을 위한 이용자 식별</td>
                    <td>연락처<br/>
                        (이메일, 핸드폰 번호)</td>
                    <td>회원탈퇴 시까지</td>
                  </tr>
                  <tr>
                    <td>교육 신청 및 채용연계에 따른 개인정보 수집</td>
                    <td>[필수] 이름, 핸드폰 번호, 이메일, 관심 카테고리, 희망 직무, 학력사항, 병역<br/>
                        [선택] 자기 소개서, 희망 연봉, 포트폴리오, 수상, 활동, 교육 연수, 기타, 자격증, 어학 시험, 외국어, 업무 경험</td>
                    <td>이력서 삭제 또는<br/>
                        회원탈퇴 시까지</td>
                  </tr>
                </table>
              </div>
              <br/><br/>
              <b>4. 개인정보의 위탁처리</b><br/>
              한국반도체아카데미는 이용자의 동의없이 정보를 외부 업체에 위탁하지 않습니다. 향후 위탁이 필요한 경우 이용자에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.<br/><br/><br/>

              <b>5. 개인정보 제3자 제공</b><br/>
              한국반도체아카데미는 원칙적으로 개인정보를 제3자에게 제공하지 않으며, 다만 아래의 경우는 예외로 합니다.<br/>
              ① 한국반도체아카데미 내 서비스 이용을 위해 이용자가 본인의 이력서 공개에 동의한 경우<br/><br/>

              <div class="table-form">
                <table class="horizontal">
                  <colgroup>
                    <col width="25%" />
                    <col />
                    <col width="25%" />
                    <col width="25%" />
                  </colgroup>
                  <tr>
                    <th>제공받는 자</th>
                    <th>제공하는 항목</th>
                    <th>제공받는 자의 이용목적</th>
                    <th>보유 및 이용기간</th>
                  </tr>
                  <tr>
                    <td>한국반도체아카데미에 가입된 기업회원 일체</td>
                    <td>[필수] 이름, 핸드폰 번호, 이메일, 관심 카테고리, 희망 직무, 학력사항, 병역<br/>
                        [선택] 자기 소개서, 희망 연봉, 포트폴리오, 수상, 활동, 교육 연수, 기타, 자격증, 어학 시험, 외국어, 업무 경험</td>
                    <td>채용 목적에 따른 인재 검색</td>
                    <td>동의일로부터 철회 요청 시까지, 회원탈퇴 시까지</td>
                  </tr>
                  <tr>
                    <td>교육공동운영기관<br/>
                        (재)경남테크노파크<br/>
                        (재)부산테크노파크<br/>
                        호서대학교</td>
                    <td>[필수] 이름, 핸드폰 번호, 이메일, 관심 카테고리, 희망 직무, 학력사항, 병역<br/>
                        [선택] 자기 소개서, 희망 연봉, 포트폴리오, 수상, 활동, 교육 연수, 기타, 자격증, 어학 시험, 외국어, 업무 경험</td>
                    <td>교육생모집, 교육생선발, 학습진행, 콘텐츠 제공 등</td>
                    <td>동의일로부터 철회 요청 시까지, 회원탈퇴 시까지</td>
                  </tr>
                </table>
              </div>
              <br/><br/>
              ② 개인정보 수집ᆞ이용 동의 거부의 권리<br/>
              이용자는 개인정보의 수집.이용에 대해서 동의를 거부하실 권리가 있습니다. 다만, 동의를 거부하는 경우, 채용 지원 서비스 이용이 제한적일 수 있습니다.<br/><br/><br/>


              <b>6. 개인정보의 보유 및 이용기간</b><br/>
              회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.<br/><br/><br/>


              <b>7. 개인정보 열람 및 정정</b><br/>
              이용자는 자기 개인정보의 열람, 정정을 원할 때는 의 홈페이지로 접속해 이용자 ID와 비밀 번호를 입력한 후, 자신의 개인정보 열람 및 정정을 진행할 수 있습니다.<br/><br/><br/>


              <b>8. 한국반도체아카데미의 개인정보 관리자</b><br/>
              한국반도체아카데미는 이용자의 개인정보를 취급을 위하여 관련 부서 및 담당자를 지정하고 있습니다.<br/>
              부서 : 인재개발지원실<br/>
              전화 : 031-622-7677<br/>
              e-mail : gawonmin@ksia.or.kr<br/><br/><br/>


              <b>9. 개인정보에 관한 민원서비스</b><br/>
              귀하께서는 한국반도체아카데미의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.<br/>
              한국반도체아카데미는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.<br/><br/>

              기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.<br/>
              ① 개인분쟁조정위원회 ( www.1336.or.kr / 1336 )<br/>
              ② 정보보호마크인증위원회 ( www.eprivacy.or.kr / 02-580-0533~4 )<br/>
              ③ 대검찰청 인터넷범죄수사센터 ( http://icic.sppo.go.kr / 02-3480-3600 )<br/>


              <!--              <KSATextButton-->
<!--                  text="[별첨] - 개인정보 처리방침 작성지침(2025.4.).pdf"-->
<!--                  @click="$download('/platformfile/public/policy/202504.pdf')"-->
<!--              />-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.lecture-wrap {
  .content-title {
    font-weight: normal;
    .select {
      min-width: 166px;
      width: fit-content;
    }
  }
  .lecture-list {
    &:first-of-type {
      margin-bottom: 40px;
    }
  }
  .table-form {
    overflow: auto;
  }
}
</style>
